import React from "react";

export const PurpleScribble = ({ style }: { style?: React.CSSProperties }) => (
  <svg
    width="1008"
    height="159"
    style={style}
    viewBox="0 0 1008 159"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1002.06 56.6183C1002.06 56.6183 796.229 264.107 684.762 253.021C574.686 242.074 610.729 117.537 546.659 49.4961C426.39 -78.2284 -1.50001 114.5 -1.50001 114.5"
      stroke="#8E33FF"
      strokeWidth="10"
      strokeLinecap="round"
    />
  </svg>
);
